// Detail views glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = Lucide geometry, as in Icon.tsx.

export { detailGlyphs };

import type { AreaGlyphs } from "../Icon";

const detailGlyphs = {} satisfies AreaGlyphs;
